import type { LifecycleProjection } from './VerificationLifecycleService';

/**
 * Face-match recovery reads of Portal's lifecycle projection. Pure functions,
 * kept apart from the lifecycle client so screens can use them without it.
 */

/**
 * A face-only comparison of a new selfie with the ID Verify Engine retained:
 * Portal's DOCUMENT_PROCESSING operation kind, waiting for Engine settlement.
 */
export const isFaceOnlyComparison = (
  projection: LifecycleProjection | null | undefined,
): boolean =>
  !!projection &&
  projection.sessionStatus === 'PENDING' &&
  !projection.terminal &&
  projection.attempt?.status === 'ACTIVE' &&
  projection.attempt.stage === 'DOCUMENT_PROCESSING' &&
  projection.attempt.operation?.kind === 'DOCUMENT_PROCESSING' &&
  projection.attempt.operation.status === 'WAITING';

/** The customer is taking a new selfie to compare with the retained ID. */
export const isFaceMatchSelfieRetry = (
  projection: LifecycleProjection | null | undefined,
): boolean => projection?.faceMatchRecovery === 'SELFIE_RETRY';

/**
 * Another selfie is offered after a new selfie was also not matched: the
 * failed operation is the face-only comparison rather than the full
 * document verification.
 */
export const isRepeatedSelfieRetryOffer = (
  projection: LifecycleProjection | null | undefined,
): boolean =>
  projection?.faceMatchRecovery === 'SELFIE_RETRY_OFFERED' &&
  projection.attempt?.operation?.kind === 'DOCUMENT_PROCESSING';
